import { createApp,reactive } from "vue";
import playLoading from "./playloading.vue";


const divDom = document.createElement('div')


divDom.setAttribute('class','loading-container')


const options = reactive({
    showToast: true,
    txt: 'Loading...',
    progress: 0,
    opacity: 1
})


const $playLoading = createApp(playLoading,{options}).mount(divDom)


const loadPlguin = {
    show({txt,opacity}) {
        options.showToast = true
        options.txt = txt
        options.opacity = opacity || 1
        document.body.appendChild($playLoading.$el)
    },
    hide() {
        options.showToast = false
        options.progress = 0
        options.imgSrc = ''
    },
    changeProgress(progress) {
        options.progress = progress
    },
    showImg(imgSrc) {
        options.imgSrc = imgSrc
    }
}


export default {
    install(app) {
        app.config.globalProperties.$playLoading =  loadPlguin 
    }
}

